import React from "react";
import { Edit as EditIcon, Delete as DeleteIcon, PublishedWithChangesRounded, } from "@mui/icons-material"; import { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, CardHeader, Grid, IconButton, TextField, Tooltip, Typography, } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import MUIXDataGrid from "../../Ayuda/MUIXDataGrid";
import { crudService } from "../../../services/CrudService";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 5,
  p: 2,
};

export default function TipoPublicacion() {
  const TITULO = "Catálogo de Tipo de Publicación";
  const TITULODETALLE = "Detalle de Tipo de Publicación";
  const BASEURL = `catalogos/tipo-publicaciones`;
  document.title = TITULO;

  const navigate = useNavigate();
  const [id, setid] = useState("");
  const [nombre, setNombre] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSave = async () => {
    try {
      const newPublicacion = { nombre };
      await crudService(BASEURL, 'crear', null, newPublicacion).then(
        () => window.location.reload()
      )
    } catch (error) {
      console.error("Error al crear publicación:", error);
    }
  };
  const handleDelete = async (id: string) => {
    Swal.fire({
      icon: "warning",
      title: "Dar de baja",
      text: "¿Estás seguro de que deseas dar de baja esta publicación?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "baja", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Baja",
              text: "La publicación ha sido dada de baja.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo dar de baja la publicación.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo dar de baja la publicación.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };

  const handleRecover = async (id: string) => {
    Swal.fire({
      icon: "info",
      title: "Recuperar",
      text: "¿Estás seguro de que deseas recuperar esta publicación?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "recupera", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Recuperado",
              text: "La publicación ha sido recuperada.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo recuperar la publicación.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo recuperar la publicación.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };
  const handleUpdate = async () => {
    if (nombre === "") {
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        text: "Favor de completar los campos",
        confirmButtonColor: "#15212f",
      });
    } else {
      try {
        const data = { nombre }
        const response = await crudService(BASEURL, "actualizar", id, data);
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Recuperado",
            text: "La publicación ha sido actualizada.",
            confirmButtonColor: "#15212f",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.message || "No se pudo actualizar la publicación.",
            confirmButtonColor: "#15212f",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar la publicación.",
          confirmButtonColor: "#15212f",
        });
      }
    }
  };

  const columns = [
    {
      field: "acciones",
      headerName: "Acciones",
      width: 180,
      headerAlign: "left",
      hideable: false,
      renderCell: (cellValues: any) => {
        return (
          <Box>
            <Tooltip title={"Editar"}>
              <IconButton color="inherit"
                onClick={() => {
                  setid(cellValues.row.id);
                  setNombre(cellValues.row.nombre);
                  handleOpen();
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            {
              cellValues.row.estatus == 'ACTIVO' ?
                <Tooltip title={"Eliminar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleDelete(cellValues.row.id); }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title={"Recuperar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleRecover(cellValues.row.id); }}
                  >
                    <PublishedWithChangesRounded />
                  </IconButton>
                </Tooltip>
            }
          </Box>
        );
      },
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 650,
      hideable: false,
      headerAlign: "left",
    },
  ];
  const camposCsv = ["Cve", "nombre", "estatus"];
  const [rows, setRows] = useState([]);
  const getAllEnlaces = async () => {
    const response = await crudService(BASEURL, 'obtener');
    if (response?.data) {
      setRows(response.data)
    }
  };

  useEffect(() => {
    getAllEnlaces();
  }, []);

  return (
    <Grid container>
      <BreadcrumbBar
        links={[
          { texto: 'Inicio', link: '/admin' },
          { texto: 'Catálogos', link: '/admin/catalogos' }
        ]
        }
        Titulo={TITULO}
      />
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} md={12} mt={2}>
          <Card sx={{ p: 0, boxShadow: 8 }}>
            <CardHeader sx={{ position: "absolute", fontFamily: "MontserratSemiBold" }} />
            <Typography variant="h5" sx={{ paddingTop: "1%", paddingLeft: "1%" }}>  {TITULO} </Typography>
            <CardContent sx={{ fontFamily: "MontserratBold", bgcolor: "" }}>
              <Box display="flex" justifyContent="flex-end">
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "right",
                    justifyContent: "right",
                    paddingBottom: "2%",
                    paddingRight: "1%",
                  }}
                >
                  <Button
                    onClick={handleOpen}
                    variant="contained"
                    sx={{ margin: "1%", color: "#FFFFFF" }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF", "&:hover": { color: "#15212f" },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}
                    >
                      Agregar
                    </Typography>
                  </Button>
                  <Button
                    onClick={() => navigate(-1)}
                    color="secondary"
                    sx={{ margin: "1%" }}
                    variant="contained">
                    <Typography
                      sx={{
                        color: "#ffffff",
                        "&:hover": {
                          color: "#15212f",
                        },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}>
                      Cancelar
                    </Typography>
                  </Button>
                </Grid>
              </Box>
              <MUIXDataGrid id={Math.random} columns={columns} rows={rows} camposCsv={camposCsv} />
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} display="flow">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h5" sx={{ padding: "1%" }}>
                          {TITULODETALLE}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label="Nombre"
                          size="small"
                          variant="outlined"
                          value={nombre}
                          onChange={(v) => { setNombre(v.target.value); }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        maxWidth="100%"
                        paddingTop={2}
                        paddingBottom={2}
                        display="flex"
                        justifyContent="end"
                      >
                        <Button
                          onClick={() => {
                            if (id === "") {
                              handleSave()
                            } else {
                              handleUpdate()
                            }
                          }
                          }
                          variant="contained"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Guardar
                        </Button>
                        <Button
                          onClick={handleClose}
                          variant="contained"
                          color="secondary"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}